var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlurLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 265,
    viewBox: "0 0 254 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.334 214.343L167.514 117.062L166.376 29.4104L180.392 29.2534C188.098 29.1488 194.305 22.5029 194.201 14.4442C194.098 6.43777 187.684 -0.10342 180.03 0.00123867L67.9538 1.5188C60.2476 1.57113 54.0413 8.2693 54.1447 16.2757C54.2481 24.3344 60.6096 30.8233 68.3158 30.7186L82.3318 30.5093L83.4697 118.161L7.1317 217.483C2.73554 223.239 0.821918 229.728 0.925357 236.112C1.23567 251.183 12.7691 265.207 29.3194 264.998L225.388 262.381C242.042 262.172 253.213 247.886 253.058 232.815C252.954 226.378 250.886 219.994 246.334 214.343ZM186.598 174.415C185.667 175.2 184.53 175.567 183.392 175.567C181.84 175.567 180.34 174.886 179.358 173.63L170.358 162.275C168.6 159.972 168.962 156.728 171.186 154.896C173.41 153.117 176.668 153.484 178.478 155.734L187.426 167.089C189.184 169.339 188.822 172.636 186.598 174.415ZM228.853 227.948C227.922 228.733 226.784 229.1 225.646 229.1C224.095 229.1 222.595 228.419 221.561 227.111L191.925 189.591C190.167 187.341 190.529 184.044 192.753 182.212C194.977 180.433 198.235 180.8 200.045 183.05L229.681 220.57C231.439 222.872 231.077 226.169 228.853 227.948Z",
    fill: "#268BD3",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurLab);
export default __webpack_public_path__ + "static/media/blurLab.487b2a3711fbb2432ea722d2d7c5c217.svg";
export { ForwardRef as ReactComponent };